<script setup lang="ts">
import {useContentStore} from "../store/content";
const contentItem = useContentStore();

const sources = contentItem.featuredImage?.filter((row) => row.tagName === "SOURCE");
const image = contentItem.featuredImage?.filter((row) => row.tagName === "IMG").pop();

</script>

<template>
    <picture class="col-span-full event-img justify-self-end">
        <source :key="index" v-for="(item, index) in sources" :media="item.media"
                :srcset="item.srcset" :sizes="item.sizes"
                :type="item.type">
        <img v-if="image" class="w-full relative -z-10"
             width="480" height="531"
             :srcset="image.srcset" :sizes="image.sizes"
             :alt="contentItem.title">
    </picture>
</template>
